//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('textileModelCategory8s', {
//        templateUrl: 'views/components/views/textileModelCategory8s/textileModelCategory8s.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'textileModelCategory8sService', function (stateService, textileModelCategory8sService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                itemsListCategories8: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadCategories8() {
//                vm.model.itemsListCategories8 = await textileModelCategory8sService.listTextileModelCategory8s();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'textilemodelcategory8':
//                        go({ textilemodelcategory8_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadCategories8();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
